import axiosInstance from "./axiosInstance";
import APIEndpoint from "./endpoint";

// GET_DROPDOWN_MASTER:"/v1/s/master/data",
// GET_DROPDOWN_COUNTRY:"/v1/s/master/country",
// GET_DROPDOWN_VOC:"/v1/s/master/voc",

export const createStakeholderCustomer = async (values) => {
  const url = `${APIEndpoint.POST_CREATESTAKEHOLDER}`;
  let payload = {
    requestObject: {
      // stakeholdersId: "12345",
      yearOfBudget: values.yearOfBudget,
      customerDate: values.customerDate,
      customerType: values.customerType,
      topicList: values.topicList,
      stakeholdersCompanyDetail: values.stakeholdersCompanyDetail,
      stakeholdersContactPersonDetail: values.stakeholdersContactPersonDetail,
      stakeholdersStaffFollowUpDetail: values.stakeholdersStaffFollowUpDetail,
    },
  };
  const res = await axiosInstance.post(url, payload);
  return res;
};

export const searchStakeholderCustomer = (searchValue, pageValue) => {
  const api = `${APIEndpoint.SEARCH_STAKEHOLDER}`;
  let payload = {
    requestObject: {
      companyName: searchValue.companyName ? searchValue.companyName : "",
      yearOfBudgetList: searchValue.yearOfBudgetList
        ? searchValue.yearOfBudgetList
        : [],
      customerDateFrom: searchValue.customerDateFrom
        ? searchValue.customerDateFrom
        : "",
      customerDateTo: searchValue.customerDateTo
        ? searchValue.customerDateTo
        : "",
      customerTypeList: searchValue.customerTypeList
        ? searchValue.customerTypeList
        : [],
      topicList: searchValue.topicList ? searchValue.topicList : [],
      nationalityList: searchValue.nationalityList
        ? searchValue.nationalityList
        : [],
      contactName: searchValue.contactName ? searchValue.contactName : "",
      contactPhone: searchValue.contactPhone ? searchValue.contactPhone : "",
      contactPosition: searchValue.contactPosition
        ? searchValue.contactPosition
        : "",
      staffName: searchValue.staffName ? searchValue.staffName : "",
      staffDetail: searchValue.staffDetail ? searchValue.staffDetail : "",
    },
    pageValue: {
      page: pageValue.page,
      pageSize: pageValue.pageSize,
      sortBy: pageValue.sortBy,
      sortDirection: pageValue.sortDirection,
    },
  };

  const res = axiosInstance.post(api, payload);
  return res;
};

export const updateStakeholderCustomer = async (values) => {
  const url = `${APIEndpoint.PUT_UPDATESTAKEHOLDER}`;

  let payload = {
    requestObject: values,
    //   stakeholdersId: values.stakeholdersId,
    //   yearOfBudget: values.yearOfBudget,
    //   customerDate: values.customerDate,
    //   customerType: values.customerType,
    //   topicList: values.topicList,
    //   stakeholdersCompanyDetail: values.stakeholdersCompanyDetail,
    //   stakeholdersContactPersonDetail: values.stakeholdersContactPersonDetail,
    //   stakeholdersStaffFollowUpDetail: values.stakeholdersStaffFollowUpDetail,
  };

  const res = await axiosInstance.put(url, JSON.stringify(payload));
  return res;
};

export const getStakeholderCustomer = async (id) => {
  const url = `${APIEndpoint.GET_STAKEHOLDER}`;

  const res = await axiosInstance.get(url + "/" + id);
  return res;
};

export const deleteStakeholderCustomer = (id) => {
  const uid = id;
  const api = APIEndpoint.DELETE_STAKEHOLDER + "/";
  const res = axiosInstance.delete(api + uid);
  return res;
};

// DropDownMaster

export const getDropDownContact = async () => {
  const url = `${APIEndpoint.GET_DROPDOWN_CONTACT}`;

  const res = await axiosInstance.get(url);
  return res;
};

export const getDropDownCountry = async () => {
  const url = `${APIEndpoint.GET_DROPDOWN_COUNTRY}`;

  const res = await axiosInstance.get(url);
  return res;
};

export const getDropDownKnowChannel = async () => {
  const url = `${APIEndpoint.GET_DROPDOWN_KNOW_CHANNEL}`;

  const res = await axiosInstance.get(url);
  return res;
};

export const getDropDownOnlineChannel = async () => {
  const url = `${APIEndpoint.GET_DROPDOWN_ONLINE_CHANNEL}`;

  const res = await axiosInstance.get(url);
  return res;
};

export const getDropDownOfflineChannel = async () => {
  const url = `${APIEndpoint.GET_DROPDOWN_OFFLINE_CHANNEL}`;

  const res = await axiosInstance.get(url);
  return res;
};
